"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIsFailure = exports.getIsSuccess = exports.getIsLoading = exports.getIsPending = exports.getError = exports.getReadyState = exports.getLocation = void 0;

var _ReadyState = _interopRequireDefault(require("./ReadyState"));

var getLocation = function getLocation(state) {
  return state.fetch.location;
};

exports.getLocation = getLocation;

var getReadyState = function getReadyState(state) {
  return state.fetch.readyState;
};

exports.getReadyState = getReadyState;

var getError = function getError(state) {
  return state.fetch.error;
};

exports.getError = getError;

var getIsPending = function getIsPending(state) {
  return getReadyState(state) === _ReadyState.default.PENDING;
};

exports.getIsPending = getIsPending;

var getIsLoading = function getIsLoading(state) {
  return getReadyState(state) === _ReadyState.default.LOADING;
};

exports.getIsLoading = getIsLoading;

var getIsSuccess = function getIsSuccess(state) {
  return getReadyState(state) === _ReadyState.default.SUCCESS;
};

exports.getIsSuccess = getIsSuccess;

var getIsFailure = function getIsFailure(state) {
  return getReadyState(state) === _ReadyState.default.FAILURE;
};

exports.getIsFailure = getIsFailure;